import React from 'react';
import cloud from '../images/cloud.png';
import mountain from '../images/mountain.png';
import vishnu from '../images/vishnu.png';
import comp from '../images/computer.png';
import styled from 'styled-components';
import './style.css';
function Mysite(){
  return(<Container>
    <div class="top">
      <img class="top_cloud" src={cloud} alt=""/>
      <h1 class="head1">I'm Vishnu.</h1>
      <p class="my">a <span class="pro">Pro</span>grammer.</p>
      <img class ="bottom_cloud" src={cloud} alt=""/>
      <img class = "mountain" src={mountain} alt=""/>
    </div>
    <div class="middle-container">
      <div class="profile">
        <hr/>
        <img src={vishnu} alt=""/>
        <h2 class="head2">Hello i am Divvela Vishnu Sai Kumar</h2>
        <p><em>Student of <strong><a href="https://www.amity.edu/">Amity University Lucknow Campus</a></strong>.</em> </p>
        <p><em>I am Studying <strong>B.tech <a href="https://www.tutorialspoint.com/artificial_intelligence/artificial_intelligence_overview.htm">Artificial Intelligence</a></strong> 4th semester in lucknow campus of Amity University.</em></p>
      </div>
      <hr/>
      <h2>My Skills.</h2>
      <img class = "computer" src={comp} alt=""/><br/><br/><br/>
      <div class="skills">

        <h3 class="h3">Design & Development</h3>
        <p>I learned C,python,java,C++,Full stack development,Databases like oracle, mysql , sqlite3, mongoose. I am currently working on React js. I am looking to collaborate on React Projects and Python Projects. To reach me click on contact me button.</p>
        <br/><br/>
      </div>
      <table class="table1" border="1" cellspacing="10">
          <tr>
            <td>
              <table cellspacing="20">
                <tr>
                  <td>C Language</td>
                  <td>⭐⭐⭐⭐</td>
                </tr>
                <tr>
                  <td>C++ Language</td>
                  <td>⭐⭐⭐ </td>
                </tr>
                <tr>
                  <td>Python</td>
                  <td> 🌟🌟🌟🌟🌟 </td>
                </tr>
                <tr>
                  <td>Java</td>
                  <td>🌟🌟🌟🌟</td>
                </tr>
              </table>
            </td>
            <td>
              <table cellspacing="20">
                <tr>
                  <td>Oracle</td>
                  <td>⭐⭐⭐⭐</td>
                </tr>
                <tr>
                  <td>My Sql</td>
                  <td>⭐⭐⭐ </td>
                </tr>
                <tr>
                  <td>Full Stack Development</td>
                  <td> 🌟🌟🌟🌟🌟 </td>
                </tr>
                <tr>
                  <td>Prolog</td>
                  <td>🌟🌟🌟🌟</td>
                </tr>
              </table>
            </td>
          </tr>
        </table>

      <br/><br/>
      <hr/>
      <p><a href="/"><h2>HOME PAGE</h2></a></p>
      <hr/>
      <div class="contact-me">
        <h2 class="h2">Get In Touch</h2>
        <a class="btn" href="mailto:divvelavishnusai@gmail.com">CONTACT ME</a><br/>
      </div>
    </div>


    <div class="bottom">
      <br/><br/>
      <a class="footer-link" href="https://www.linkedin.com/">LinkedIn</a>
      <a class="footer-link" href="https://twitter.com/">Twitter</a>
      <a class="footer-link" href="https://www.appbrewery.co/">Website</a><br/><br/><br/>
      <p style = {{color : "white"}}>© 2021 Vishnu Divvela.</p>
    </div>
        </Container>);
}

export default Mysite;

const Container = styled.div`
  
`
